import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDevTicket } from "../types/Dev-TicketsTypes";

interface IDevTicketState {
  devTickets: IDevTicket[];
  myDevTickets: IDevTicket[];
  selectedDevTicket: IDevTicket | null;
  error: string;
  isLoading: boolean;
  devTicketActionLoading: boolean;
}

const initialState: IDevTicketState = {
  devTickets: [],
  myDevTickets: [],
  selectedDevTicket: null,
  error: "",
  isLoading: false,
  devTicketActionLoading: false,
};

export const devTicketSlice = createSlice({
  name: "devTicket",
  initialState,
  reducers: {

    devTicketsFetching(state) {
      state.isLoading = true;
      state.error = "";
    },

    devTicketsFetchingSuccess(state, action: PayloadAction<IDevTicket[]>) {
      state.isLoading = false;
      state.error = "";
      state.devTickets = action.payload;
    },

    devTicketsFetchingFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    myDevTicketsFetching(state) {
      state.isLoading = true;
      state.error = "";
    },

    myDevTicketsFetchingSuccess(state, action: PayloadAction<IDevTicket[]>) {
      state.isLoading = false;
      state.error = "";
      state.myDevTickets = action.payload;
    },

    myDevTicketsFetchingFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    devTicketFetching(state) {
      state.isLoading = true;
      state.error = "";
    },

    devTicketFetchingSuccess(state, action: PayloadAction<IDevTicket>) {
      state.isLoading = false;
      state.error = "";
      state.selectedDevTicket = action.payload;
    },

    devTicketFetchingFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    addDevTicketLoading(state) {
      state.devTicketActionLoading = true;
      state.error = "";
    },

    addDevTicketSuccess(state, action: PayloadAction<IDevTicket>) {
      state.devTicketActionLoading = false;
      state.error = "";

      state.selectedDevTicket = action.payload;

      state.devTickets.unshift(action.payload);
      state.myDevTickets.unshift(action.payload);
    },

    addDevTicketFailed(state, action: PayloadAction<string>) {
      state.devTicketActionLoading = false;
      state.error = action.payload;
    },

    completeDevTicketLoading(state) {
      state.devTicketActionLoading = true;
      state.error = "";
    },

    completeDevTicketSuccess(state, action: PayloadAction<IDevTicket>) {
      state.devTicketActionLoading = false;
      state.error = "";

      state.selectedDevTicket = action.payload;

      state.devTickets = state.devTickets.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );

      state.myDevTickets = state.myDevTickets.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );
    },

    completeDevTicketFailed(state, action: PayloadAction<string>) {
      state.devTicketActionLoading = false;
      state.error = action.payload;
    },

    clearSelectedDevTicket(state) {
      state.selectedDevTicket = null;
    },
  },
});


export default devTicketSlice.reducer;